/**
 * The BlogPostList view
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, CardText, CardBody, CardTitle, Button } from "reactstrap";
import ResponsivePicture from "../ResponsivePicture";
import LazyLoad from "react-lazyload";

/**
 * The `show` container for an BlogPost.
 * Both the component and the connected component are exported for testing purpose
 */
export class BlogPostsListView extends Component {
  /**
   * renders the faq data
   */
  // mediumData={{
  //   { srcSet: '//' + image.webp_url + ' 640w', type: "image/webp" },
  //   { srcSet: '//' + image.jpeg_url + ' 640w', type: "image/jpeg" }
  // }}
  // sizes="(min-width: 87.5em) calc(466.66px - 30px),(min-width: 75em) calc(33.33vw - 30px), (min-width: 62em) calc(360px - 30px), (min-width: 48em) calc(540px - 30px), (min-width: 36em) calc(100vw - 30px)"

  render() {
    const { title, slug, onCardClick, preview, image } = this.props;

    const navigateToPost = () => {
      onCardClick(slug);
    };
    return (
      <div className="mb-4">
        <Card>
          {image && (
            <LazyLoad>
              <ResponsivePicture
                mediumData={{
                  url: image.jpeg_url,
                  webp_url: image.webp_url,
                  metadata: {
                    width: 640,
                    height: 640,
                  },
                }}
                className="card-img-top"
                altTitle={title}
                onClick={navigateToPost}
              />
            </LazyLoad>
          )}
          <CardBody>
            <CardTitle className="h5">{title}</CardTitle>
            {preview && <CardText>{preview}</CardText>}
            <div className="text-right">
              <Button
                onClick={navigateToPost}
                outline
                color="primary"
                size="sm"
              >
                {this.context.t("read article")}
              </Button>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

/**  define proptype for the 'translation' function  */
BlogPostsListView.contextTypes = {
  t: PropTypes.func,
};

/** export the redux connected component and add a frontload call */
export default BlogPostsListView;
